import React from 'react';
import { StarIcon } from 'lucide-react';
import { TransformCTA } from '../TransformCTA';
import { testimonials } from '../../data/content';
function Stars() {
  return <div className="flex gap-0.5" aria-label="Rated 5 out of 5" data-id="element-205" data-mp="3hfd1aizn98tm">
      {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-206" data-mp="3r7infc37sw0w" />)}
    </div>;
}
export function Testimonials() {
  return <section className="w-full bg-bone-50 px-5 py-14 sm:py-20" data-id="element-207" data-mp="oeks29qn99">
      <div className="mx-auto w-full max-w-xl lg:max-w-5xl" data-id="element-208" data-mp="421gws65k8bf">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-ink-900 sm:text-[34px]" data-id="element-209" data-mp="44nlqk1ns9py">
          What healthcare professionals are saying about the Route
        </h2>
        <div className="mt-4 flex flex-col items-center gap-2" data-id="element-210" data-mp="dymp1mdgxzjh">
          <Stars data-id="element-211" data-mp="2aukc78eb5rdu" />
          <p className="text-[13px] font-semibold text-ink-900/60" data-id="element-212" data-mp="2av3p2ap3ppl0">
            4.9/5 · more than 1,000 healthcare professionals already use the Route
          </p>
        </div>

        <ul className="mt-10 grid gap-4 lg:grid-cols-3 lg:gap-5" data-id="element-213" data-mp="1slawzf7xoj7j">
          {testimonials.map(item => <li key={item.name} className="flex flex-col rounded-2xl border border-bone-200 bg-white p-5 shadow-card sm:p-6" data-id="element-214" data-mp="1ns9ekx8iq1j7">
              <Stars data-id="element-215" data-mp="1etxkumccunmj" />
              <blockquote className="mt-4 flex-1 text-[14px] leading-relaxed text-ink-900/75 sm:text-[15px]" data-id="element-216" data-mp="1eupdppeki794">
                « {item.quote} »
              </blockquote>
              <div className="mt-5 flex items-center gap-3 border-t border-bone-200 pt-4" data-id="element-217" data-mp="26k29ix75dwtk">
                <img src={item.photo} alt={`Portrait of ${item.name}`} className="h-12 w-12 shrink-0 rounded-full object-cover" loading="lazy" data-id="element-218" data-mp="22i78ltt4plgb" />
                <div className="min-w-0" data-id="element-219" data-mp="r54ud5ei57zb">
                  <p className="text-[14px] font-bold text-ink-900" data-id="element-220" data-mp="m4gudu8apgsy">{item.name}</p>
                  <p className="text-[12px] font-medium text-ink-900/55" data-id="element-221" data-mp="m6jputs7w252">
                    {item.role} · {item.country}
                  </p>
                </div>
              </div>
            </li>)}
        </ul>

        <TransformCTA tone="light" headline="Join the +1,000 healthcare professionals already using the Route." data-id="element-222" data-mp="el7tkpduuqfi" />
      </div>
    </section>;
}